import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Row } from 'reactstrap';
import { without, range } from 'underscore';
import Checkbox from '../field/checkbox';

const OPTIONS = [
  {
    label: 'Any',
    value: ''
  },
  'Assisted Living Available',
  // 'BBQ - Picnic',
  // 'Basketball',
  // 'Beach - Private',
  'Beach Access',
  'Beach Club Available',
  // 'Beauty Salon',
  {
    label: 'Bike and Jog Path',
    value: 'Bike And Jog Path'
  },
  // 'Bike Storage',
  // 'Billiards',
  // 'Boat Storage',
  // 'Bocce Court',
  // 'Business Center',
  // 'Cabana',
  'Clubhouse',
  // 'Common Laundry',
  'Community Boat Dock',
  'Community Boat Lift',
  'Community Boat Ramp',
  'Community Boat Slip',
  // 'Community Park',
  'Community Pool',
  // 'Community Room',
  {
    label: 'Community Spa/Hot Tub',
    value: 'Community Spa/Hot tub'
  },
  // 'Concierge Services',
  'Dog Park',
  // 'Exercise Room',
  // 'Extra Storage',
  // 'Fishing Pier',
  'Fitness Center Attended',
  // 'Full Service Spa',
  // 'Golf Course',
  // 'Guest Room',
  // 'Hobby Room',
  // 'Horses OK',
  // 'Internet Access',
  // 'Lakefront Beach',
  // 'Library',
  // 'Marina',
  'Pickleball',
  // 'Play Area',
  // 'Private Beach Pavilion',
  // 'Private Membership',
  // 'Putting Green',
  // 'Racquet Ball',
  // 'Restaurant',
  // 'Sauna',
  // 'See Remarks',
  // 'Shopping',
  // 'Shuffleboard',
  // 'Sidewalk',
  {
    label: 'Horse Stable',
    value: 'Stable - Horse'
  },
  // 'Streetlight',
  'Tennis Court',
  // 'Theater',
  // 'Trash Chute',
  'Underground Utility'
  // 'Vehicle Wash Area',
  // 'Volleyball',
  // 'Water Skiing'
];

function RenderCheckbox(props) {
  const { input, meta, ...checkboxProps } = props;
  const checked =
    (input.value && input.value.length === 0 && props.value === '') ||
    (input.value.indexOf && input.value.indexOf(props.value) !== -1);
  return (
    <Checkbox
      {...checkboxProps}
      checked={checked}
      onChange={e => {
        const { checked } = e.target;

        var newValue = [].concat(input.value);

        if (checked && props.value === '') {
          newValue = [];
        } else if (checked && newValue.indexOf(props.value) === -1) {
          newValue.push(props.value);
        } else {
          newValue = without(newValue, props.value);
        }

        if (newValue.indexOf('') !== -1) {
          newValue = without(newValue, '');
        }

        return input.onChange(newValue);
      }}
    />
  );
}

class AmenityFilter extends PureComponent {
  static contextTypes = {
    theme: PropTypes.object
  };

  render() {
    const BS = this.context.theme;
    const labelClassName = `${BS.justifyContentStart} ${BS.mb1}`;
    const { className, numCols, numColsSm, numInnerCols, numInnerColsSm, ...props } =
      this.props;
    const colSize = Math.ceil(12 / numCols);
    const colSizeSm = Math.ceil(12 / numColsSm);
    const colInnerSize = Math.ceil(12 / numInnerCols);
    const colInnerSizeSm = Math.ceil(12 / numInnerColsSm);
    const numPerCol = Math.ceil(OPTIONS.length / numCols);
    const numPerInnerCol = Math.ceil(numPerCol / numInnerCols);

    var i = 0;

    return (
      <Row className={className}>
        {range(numCols).map(col => {
          return (
            <Col key={col} sm={colSizeSm} md={colSize}>
              <FormGroup>
                <Row>
                  {range(numInnerCols).map(innerCol => {
                    return (
                      <Col key={innerCol} sm={colInnerSizeSm} md={colInnerSize}>
                        {range(numPerInnerCol).map(() => {
                          const data = OPTIONS[i];
                          i++;
                          return data ? (
                            <RenderCheckbox
                              {...props}
                              key={i}
                              className={labelClassName}
                              value={data.value !== undefined ? data.value : data}
                              label={data.label || data}
                            />
                          ) : null;
                        })}
                      </Col>
                    );
                  })}
                </Row>
              </FormGroup>
            </Col>
          );
        })}
      </Row>
    );
  }
}

AmenityFilter.defaultProps = {
  numCols: 3,
  numInnerCols: 2,
  numColsSm: 2,
  numInnerColsSm: 1
};
export { OPTIONS };
export default AmenityFilter;



// WEBPACK FOOTER //
// ./src/components/form/filter/amenity-filter.js